import { TAddExistingResource } from '@/console/features/groups/components/add-existing-resources/add-existing-resources.types';
import { TResourceGroupItem } from '@/console/features/groups/components/groups.types';
import { TGroupResourceItem } from '@/shared/features/groups/context/groups-config-context.types';

// Form strips __typename before onSubmit, but the update dispatcher keys on it client-side.
export const withTypename = (
  resource: TAddExistingResource,
  typename: TResourceGroupItem['__typename'],
): TGroupResourceItem => ({ ...resource, __typename: typename });
